import React from 'react'
import { Search } from '../components/search/search'
import { ReactComponent as NewRoom } from '../img/newRoom.svg'
import '../styles/technical.css'
import { useNavigate, useParams } from 'react-router-dom'
import database from '../img/database.svg'
import chevron from '../img/Chevron White.svg'
import axiosInstance from '../auth/axiosInstance'

function Technical() {

    const param = useParams()
    const navigate = useNavigate()
    const [data, setData] = React.useState([])
    const [initialData, setInitialData] = React.useState([])

    function getData() {
        axiosInstance(`room/site/${param.id}`)
            .then(res => {
                setData(res.data)
                setInitialData(res.data)
            })
            .catch(err => console.log(err))
    }

    React.useEffect(() => {
        getData()
    }, [])

    return (
        <section style={{ overflowY: 'hidden' }} className='tech-body'>
            <div style={{ marginTop: 20, fontSize: 'clamp(16px, 1vw, 24px)' }}>
                <h1 style={{ fontWeight: 600 }}>Rack Count</h1>
            </div>
            <div className='box-site-title'>
                <img src={database} alt='database' />
                <h1>{param.dc} DH</h1>
            </div>

            <p>Select a DH to insert Rack quantity </p>

            <section className='rooms-area-container'>
                <section className='rooms-area'>
                    <Search initialData={initialData} set={setData} style={{ boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05), 0px 24px 7px 0px rgba(0, 0, 0, 0.00), 0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px -1px 4px 0px rgba(0, 0, 0, 0.08)', width: '100%' }} placeholder='Search Rooms' />

                    <div className='rows-card-area'>
                        <div className='container-room-card'>
                            {
                                data.map((value, i) => {
                                    return (
                                        <div className='card-room'>
                                            <div>
                                                <NewRoom className='card-room_img' />
                                                <h1>{value.room}</h1>
                                            </div>
                                            <button onClick={() => navigate(`table`, {
                                                state: { 
                                                    idRoom: value.id, 
                                                    nameRoom: value.room, 
                                                    dc: param.dc, 
                                                    id: param.id }
                                            })}>
                                                <img src={chevron} alt='chevron' />
                                            </button>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>
            </section>

        </section>
    )
}

export default Technical